import Button from '../sydo/prefab/buttons/Button.js';
import { Colors } from '../consts/Colors.js';
import { Sizes } from '../consts/Sizes.js';
import { Fonts } from '../consts/Fonts.js';

export default class ButtonRounded extends Button {
    constructor(
        scene,
        x,
        y,
        w,
        h,
        text,
        text_color,
        box_color,
        hasAnStroke = false,
        stroke_color,
        hasAnIcon = false,
        alignLeft = false, // <-- optionnel
        icon = null,
        url
    ) {
        const params = {
            width: w,
            height: h,
            text,
            text_color,
            box_color,
            hasAnStroke,
            stroke_color,
            hasAnIcon,
            alignLeft,
            icon,
            Url: url,
        };

        super(scene, x, y, params);

        this.defaultBoxColor = box_color;
        this.defaultTextColor = text_color;
    }

    addBody(params) {
        // --- Ajout du fond ---
        this.back = this.scene.add
            .rexRoundRectangle(0, 0, params.width, params.height, params.height / 2, 0xffffff)
            .setOrigin(0.5);

        if (params.box_color === 'transparent') {
            this.back.setFillStyle(0xffffff, 0);
        } else {
            this.back.setFillStyle(params.box_color, 1);
        }

        if (params.hasAnStroke) {
            this.back.setStrokeStyle(2, params.stroke_color);
        }
        this.add(this.back);

        // --- Gestion de l'icône ---
        if (params.hasAnIcon) {
            this.icon = this.scene.add.image(params.width / 2 - 35, 0, params.icon).setOrigin(0.5);
            this.add(this.icon);
        }

        // --- Gestion du texte ---
        let textX = -10;
        let textAlign = 'center';
        let textOriginX = 0.5;

        if (params.alignLeft) {
            textX = -params.width / 2 + 30; // petit padding à gauche
            textAlign = 'left';
            textOriginX = 0;
        }

        const fontSize = params.hasAnIcon ? Sizes.Text.h4 : Sizes.Text.p;
        const fontFamily = params.hasAnIcon ? Fonts.Text.h3 : 'CenturyGothic';

        this.text = this.scene.add
            .rexTagText(textX, 0, params.text, {
                fontSize,
                fontFamily,
                align: textAlign,
                color: params.text_color,
                backgroundColor: 'transparent',
            })
            .setOrigin(textOriginX, 0.5);

        this.add(this.text);

        if (this.text.height > params.height) {
            this.back.height = this.text.height + 10;
        }

        // --- Interaction ---
        this.setSize(this.back.width, this.back.height);
        this.setInteractive({ useHandCursor: true });
        this.on('pointerover', this.pointerOver, this);
        this.on('pointerout', this.pointerOut, this);
    }

    pointerOut() {
        this.back.setFillStyle(Colors.Elmt.Yellow, 1);
    }

    pointerOver() {
        this.back.setFillStyle(Colors.Elmt.Yellow, 0.8);
    }

    setLocked() {
        this.isLocked = true;
        this.setAlpha(0.6);
        this.disableInteractive();
        this.back.setFillStyle(Colors.Elmt.White);
        this.text.setColor(Colors.Text.BleuNovotel);
    }

    setUnlocked() {
        this.isLocked = false;
        this.setAlpha(1);
        this.setInteractive();
        this.back.setFillStyle(this.defaultBoxColor);
        this.text.setColor(this.defaultTextColor);
    }

    setText(txt) {
        this.text.setText(txt);
    }

    setTextColor(color) {
        this.text.color = color;
    }

    setTextFont(fontFamily) {
        this.text.fontFamily = fontFamily;
    }

    setTextSize(fontSize) {
        this.text.fontSize = fontSize;
    }
}
